module.exports = __webpack_public_path__ + "img/emoji_hover.da474e36.svg";